<!-- 补剂详情 -->
<template>
  <div
    class="tonic-detail"
    v-pageBuried
    :data-page-buried="'BG_SHANGPINXQ_' + id"
  >
    <div v-if="isToast">
      <div class="detail-tabbar" @click="bindClose">
        <div class="tabbar"></div>
      </div>
      <div class="detail-top-container">
        <div class="detail-top">
          <div>补剂详情</div>
          <div class="share-btn" v-if="isApp" @click="bindShare"
            ><span class="iconfont icon-share"></span><span>分享</span></div
          >
        </div>
      </div>
    </div>
    <div class="tonic-scroll">
      <div
        class="tonic-container"
        :class="{ 'show-buy-padding': tonicData && tonicData.jump_url }"
        v-if="tonicData"
      >
        <div class="tonic-info">
          <div class="info-left">
            <img class="info-brand" :src="tonicData.brand_img" alt="" />
            <div class="info-name">{{ tonicData.p_title }}</div>
            <div class="info-eat-num">{{ tonicData.eat_count }}人正在吃</div>
            <div class="area-content">
              <img class="area-image" :src="tonicData.area_image" alt="" />
              <div class="product-high-lights">{{ tonicData.highlights }}</div>
              <img
                class="crown-image"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/df45efe9c43bd0742f22fd740028360a.png"
                alt=""
              />
            </div>
          </div>
          <img class="info-image" :src="tonicData.image" alt="" />
        </div>
        <!-- 描述 -->
        <div class="info-desc">{{ tonicData.introduction }}</div>
        <div class="auditor-info">
          <span>已由</span>
          <img
            class="auditor-avatar"
            :src="tonicData.expert_head_image"
            alt=""
          />
          <span class="auditor-desc"
            >{{ tonicData.expert_name }}完成权威审核</span
          >
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d0a2a0f3100a6b92ba6c0aaba031da99.png"
            alt=""
          />
        </div>
        <div class="table-list">
          <div class="table-item">
            <div class="item-title">产品剂型</div>
            <div class="item-text">{{ tonicData.t_title }}</div>
          </div>
          <div class="table-item">
            <div class="item-title">包装种类</div>
            <div class="item-text">{{ tonicData.max_unit_txt }}</div>
          </div>
          <div class="table-item">
            <div class="item-title">品牌</div>
            <div class="item-text">{{ tonicData.b_title }}</div>
          </div>
          <div class="table-item">
            <div class="item-title">产地</div>
            <div class="item-text">{{ tonicData.area_name }}</div>
          </div>
        </div>
        <div class="line-item" v-if="tonicData.able_crowds.length">
          <div class="line-gray">适用人群</div>
          <div class="line-bottom">
            <div class="bottom-text"
              ><span v-for="(item, index) in tonicData.able_crowds" :key="index"
                >{{ item
                }}{{
                  index < tonicData.able_crowds.length - 1 ? '、' : ''
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="line-item" v-if="tonicData.disable_crowds.length">
          <div class="line-gray">禁用人群</div>
          <div class="line-bottom">
            <div class="bottom-text"
              ><span
                v-for="(item, index) in tonicData.disable_crowds"
                :key="index"
                >{{ item
                }}{{
                  index < tonicData.disable_crowds.length - 1 ? '、' : ''
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="line-item">
          <div class="line-gray">规格</div>
          <div class="line-bottom">
            <div class="bottom-text">{{ tonicData.specs_name }}</div>
          </div>
        </div>
        <div class="line-item" v-if="tonicData.element.length">
          <div class="line-gray">主要营养成分</div>
          <div class="line-bottom">
            <div
              class="nutritional-container"
              :class="{ 'container-limit': !showMore }"
            >
              <div class="nutritional-header">
                <div>营养成分</div>
                <div>每份含量（1{{ tonicData.min_unit_txt }}）</div>
              </div>
              <div class="nutritional-list">
                <div
                  class="nutritional-item"
                  v-for="(item, index) in tonicData.element"
                  :key="index"
                >
                  <div class="item-name">{{ item.title }}</div>
                  <div class="item-num">{{ item.content }}</div>
                </div>
              </div>
              <div
                class="more"
                :class="{ 'more-mask': !showMore }"
                v-if="tonicData.element.length >= 10"
              >
                <div class="text" @click="bindToggle"
                  >{{ showMore ? '收起' : '展开'
                  }}<span
                    class="iconfont icon-black"
                    :class="{ 'rotate-icon': showMore }"
                  ></span
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="line-item" v-if="tonicData.efficacy.length">
          <div class="line-gray">功效</div>
          <div class="line-bottom">
            <div class="effect-scroll">
              <div class="effect-list">
                <div
                  class="effect-item"
                  v-for="(item, index) in tonicData.efficacy"
                  :key="index"
                >
                  <img class="effect-item-icon" :src="item.image" />
                  <div class="effect-item-name">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line-item">
          <div class="line-gray">使用建议</div>
          <div class="line-bottom">
            <div class="suggest-container">
              <div class="recommend-container" v-if="tonicData.usage.length">
                <div class="recommend-header">
                  <div>用法推荐</div>
                  <div class="header-right">用量</div>
                </div>
                <div class="recommend-list">
                  <div
                    class="recommend-item"
                    v-for="(item, index) in tonicData.usage"
                    :key="index"
                  >
                    <div class="item-name">{{ item.title }}</div>
                    <div class="item-num">{{ item.use_description }}</div>
                  </div>
                </div>
              </div>
              <div class="item-list">
                <div class="item-list-item" v-if="tonicData.tips">
                  <div class="item-title">营养贴士</div>
                  <div class="item-text">{{ tonicData.tips }}</div>
                </div>
                <div
                  class="item-list-item"
                  v-if="tonicData.suggest_separating_eat"
                >
                  <div class="item-title">建议不要一起吃</div>
                  <div class="item-text"
                    ><span
                      v-for="(item, index) in tonicData.suggest_separating_eat"
                      :key="index"
                      >{{ item
                      }}{{
                        index < tonicData.suggest_separating_eat.length - 1
                          ? '、'
                          : ''
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="space-line"></div>
        <!-- 营养师推荐购买 -->
        <div class="dietitian-recommend" v-if="dietitianRecommend.length">
          <div class="recommend-title">
            <div>营养师指导购买</div>
            <img
              class="recommend-flag"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/436e60c4f565d42bb0773212e898de87.png"
              alt=""
            />
          </div>
          <div class="goods-list">
            <div
              class="goods-item"
              v-for="(item, index) in dietitianRecommend"
              :key="index"
              v-buried
              :data-buried="
                'BG_SHANGPINXQ_TUIJIANBUY_' + item.child_tonic_product_id
              "
            >
              <div class="item-top">
                <img
                  class="item-icon"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/df45efe9c43bd0742f22fd740028360a.png"
                  alt=""
                />
                <div class="item-name">{{ item.combination_title }}</div>
                <div class="group-list">
                  <div class="add iconfont icon-jiahao"></div>
                  <div class="group-item">
                    <img
                      class="group-image"
                      :src="item.combination_image"
                      alt=""
                    />
                  </div>
                  <div class="group-item">
                    <img class="group-image" :src="tonicData.image" alt="" />
                  </div>
                </div>
              </div>
              <div class="item-bottom">
                <div class="item-left">
                  <img class="item-icon" :src="item.combination_image" alt="" />
                  <img class="item-brand" :src="item.brand_img" alt="" />
                </div>
                <div class="item-center">
                  <div class="item-name">{{ item.product_title }}</div>
                  <div class="tag-list"
                    ><span
                      class="tag-item"
                      v-for="(item1, index1) in item.efficacy"
                      :key="index1"
                      >{{ item1.title }}</span
                    >
                  </div>
                  <div class="item-space"></div>
                  <div class="item-b-content">
                    <div class="item-num">{{
                      item.combination_specs_name
                    }}</div>
                    <div class="item-btn">
                      <div
                        class="buy-btn"
                        v-if="item.jump_url"
                        @click="bindBuyRecommendTonic(item)"
                        v-clickBuried
                        :data-click-buried="
                          'CLICK_BUTTON_SHANGPINXQ_TUIJIANBUY_' +
                          item.child_tonic_product_id
                        "
                      >
                        去购买</div
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="fixed-btn"
        v-if="tonicData && tonicData.jump_url && tonicData.state"
      >
        <div
          class="create-btn"
          @click="bindBuyTonic"
          v-clickBuried
          :data-click-buried="'CLICK_BUTTON_SHANGPINXQ_BUY_' + id"
          ><span class="iconfont icon-gouwuche1"></span><span>去购买</span>
          <!-- <WxOpenLaunchApp :extinfo="extinfo" /> -->
        </div>
      </div>
    </div>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import ShareComponent from '@/components/app/share/share.vue'
import { eventObj } from '@/components/app/share/share-method.js'
import { getUrlQuery } from '@/common/common.js'
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    isToast: {
      type: Boolean,
      default: true
    }
  },
  components: { WxOpenLaunchApp, ShareComponent },
  data() {
    return {
      isApp: false,
      extinfo: '/home?pageTag=0',
      showMore: false,
      tonicData: null,
      dietitianRecommend: [],
      showShare: false,
      qrcodeUrl: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 3,
          copy: true,
          className: 'share-copy-btn'
        }
      ],
      shareOptions: {
        desc: '快来打开看看，加速燃脂、抗炎抗氧的秘密就在这里哦！',
        title: '向你分享了一个营养闹钟计划！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8865341b353336bfe340f5e9ebf087.png' // 分享的缩略图的url
      }
    }
  },
  watch: {
    id() {
      this.getTonicDetail()
      this.getDietitianRecommend()
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.qrcodeUrl =
      location.origin + '/nutrition-clock/tonic-detail?id=' + this.id
    this.getTonicDetail()
    this.getDietitianRecommend()
  },
  methods: {
    bindCancel() {
      this.showShare = false
    },
    bindClose() {
      this.$emit('close')
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      // let name = this.$store.state.userInfo.user && this.$store.state.userInfo.user.truename;
      shareOptions.title = this.tonicData.p_title
      shareOptions.desc = this.tonicData.introduction
      shareOptions.thumbnail = this.tonicData.image
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    bindBuyRecommendTonic(item) {
      this.bindJumpBuy(item.jump_url)
    },
    bindBuyTonic() {
      this.bindJumpBuy(this.tonicData.jump_url)
    },
    bindJumpBuy(url) {
      if (this.$http._isApp()) {
        this.$betterwe.jumpRoute(url)
      } else {
        if (url.startsWith('/web') || url.startsWith('/wmOtherPage')) {
          url = getUrlQuery('url', url)
          if (url) {
            location.href = url
          }
        }
      }
    },
    bindShare() {
      this.showShare = true
    },
    /* 获取补剂详情 */
    async getTonicDetail() {
      if (!this.id) {
        return
      }
      let params = {
        product_id: this.id
      }
      this.$toast.loading()
      let res = await this.$http
        .postBaseApp('api/v1/TonicShow/getTonicDetail', params)
        .catch(() => {})
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.tonicData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 营养师指导购买 */
    async getDietitianRecommend() {
      if (!this.id) {
        return
      }
      let params = {
        product_id: this.id
      }
      let res = await this.$http.postBaseApp(
        'api/v1/TonicShow/getDietitianRecommend',
        params
      )
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.dietitianRecommend = res.data || []
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindToggle() {
      this.showMore = !this.showMore
    }
  }
}
</script>
<style lang="scss" scoped>
.tonic-detail {
  position: relative;
  color: rgba(0, 0, 0, 0.8);
  height: 85vh;
  background: #f9f9f9;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .detail-tabbar {
    padding-top: 6px;
    padding-bottom: 9px;
    display: flex;
    justify-content: center;

    .tabbar {
      width: 35px;
      height: 3px;
      border-radius: 2px;
      background: #cccccc;
    }
  }

  .detail-top-container {
    padding: 0px 16px 0px;
  }

  .detail-top {
    padding-bottom: 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);

    .share-btn {
      width: 62px;
      height: 22px;
      border-radius: 11px;
      border: 1px solid rgba(151, 151, 151, 0.5);
      color: rgba(0, 0, 0, 0.5);
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }

  .tonic-scroll {
    flex: 1;
    flex-shrink: 0;
    height: 100%;
    overflow-y: scroll;
  }

  .fixed-btn {
    position: fixed;
    z-index: 999;
    width: 100%;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 10px 20px 5px;
    background: #ffffff;
    @include paddingBottom(5px);

    .create-btn {
      position: relative;
      text-align: center;
      height: 48px;
      line-height: 48px;
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      background: #03d4e6;
      border-radius: 24px;

      .iconfont {
        font-size: 20px;
        font-weight: normal;
        margin-right: 6px;
      }
    }
  }

  .tonic-container {
    padding: 7px 20px 0px;

    .tonic-info {
      display: flex;
      align-items: flex-end;
      margin-bottom: 12px;

      .info-left {
        flex: 1;
        overflow: hidden;
        flex-shrink: 0;
        margin-right: 20px;

        .info-name {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          line-height: 25px;
          margin-bottom: 4px;
        }

        .info-eat-num {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 6px;
        }

        .info-brand {
          width: 68px;
          height: 23px;
          object-fit: contain;
          border-radius: 4px;
          overflow: hidden;
          margin-bottom: 4px;
        }

        .area-content {
          width: 176px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          background: linear-gradient(
            270deg,
            rgba(238, 238, 238, 0) 0%,
            #fff0df 100%
          );
          padding: 0px 6px;
          height: 26px;
          border-radius: 13px;

          .area-image {
            width: 18px;
            height: 18px;
            object-fit: contain;
            margin-right: 4px;
          }

          .product-high-lights {
            max-width: 120px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 10px;
            font-family: MiSans, MiSans;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 10px;
            background: linear-gradient(180deg, #ab7024 0%, #66400f 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 4px;
          }

          .crown-image {
            width: 21px;
            height: 14px;
            object-fit: contain;
          }
        }
      }

      .info-image {
        width: 110px;
        height: 110px;
        object-fit: contain;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 10px;
      }
    }

    .info-desc {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      margin-bottom: 7px;
    }

    .auditor-info {
      display: flex;
      align-items: center;
      font-size: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ab7024;
      line-height: 20px;
      height: 30px;
      background: linear-gradient(270deg, #fff7ee 0%, #fff0df 100%);
      border-radius: 4px;
      padding: 0px 10px;
      margin-bottom: 16px;

      .auditor-avatar {
        width: 16px;
        height: 16px;
        object-fit: cover;
        border-radius: 50%;
        overflow: hidden;
        margin: 0px 4px;
      }

      .auditor-desc {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .logo {
        width: 72px;
        height: 10px;
      }
    }

    .table-list {
      padding: 10px 0px;
      display: flex;
      align-items: flex-start;
      border-top: 2px solid rgba(0, 0, 0, 0.3);
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      margin-bottom: 23px;

      .table-item {
        width: 25%;
        text-align: center;
        padding: 0px 4px;
        box-sizing: border-box;

        .item-title {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
          margin-bottom: 8px;
        }

        .item-text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          line-height: 17px;
        }
      }
    }

    .line-item {
      .line-gray {
        padding: 0px 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 30px;
        background: #f1f1f1;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 30px;
      }

      .line-bottom {
        padding-bottom: 20px;

        .bottom-text {
          margin-top: 15px;
          padding-left: 12px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }
    }

    .nutritional-container {
      position: relative;
      margin-top: 17px;
      padding: 0px 12px 20px;

      .more {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 61px;

        .text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          line-height: 17px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0%);
          display: flex;
          align-items: center;
          justify-content: center;

          .iconfont {
            font-size: 10px;
            margin-left: 4px;
            width: 12px;
            height: 12px;
            box-sizing: border-box;
            border: 1px solid #979797;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s all ease;
          }

          .rotate-icon {
            transform: rotate(180deg);
          }
        }
      }

      .more-mask {
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(252, 252, 252, 0.85) 51%,
          #f9f9f9 100%
        );
      }

      .nutritional-header {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
      }

      .nutritional-list {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;

        .nutritional-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;

          .item-name {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            margin-right: 10px;
          }

          .item-num {
            text-align: center;
            width: 90px;
          }
        }

        .nutritional-item:last-child {
          margin-bottom: 0;
        }
      }
    }

    .container-limit {
      max-height: 320px;
      overflow: hidden;
    }

    .effect-scroll {
      padding-top: 15px;
      overflow-x: scroll;

      .effect-list {
        display: inline-flex;
        flex-wrap: nowrap;

        .effect-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          margin-right: 24px;

          .effect-item-icon {
            width: 40px;
            height: 40px;
            object-fit: contain;
            margin-bottom: 13px;
          }

          .effect-item-name {
            width: 50px;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 17px;
          }
        }

        .effect-item:last-child {
          margin-right: 0;
        }
      }
    }

    .suggest-container {
      padding-left: 12px;
    }

    .recommend-container {
      margin-top: 17px;
      margin-bottom: 25px;

      .recommend-header {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .header-right {
          width: 133px;
        }
      }

      .recommend-list {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;

        .recommend-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;

          .item-name {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            margin-right: 10px;
          }

          .item-num {
            width: 133px;
          }
        }

        .recommend-item:last-child {
          margin-bottom: 0;
        }
      }
    }

    .item-list {
      .item-list-item {
        margin-bottom: 20px;

        .item-title {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          line-height: 17px;
          margin-bottom: 8px;
        }

        .item-text {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }

      .item-list-item:last-child {
        margin-bottom: 0;
      }
    }

    .space-line {
      height: 20px;
      border-bottom: 2px solid rgba(0, 0, 0, 0.3);
    }

    .dietitian-recommend {
      padding: 20px 0px;

      .recommend-title {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        line-height: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 22px;

        .recommend-flag {
          width: 152px;
          height: 31px;
        }
      }

      .goods-list {
        .goods-item {
          position: relative;
          border-radius: 6px;
          overflow: hidden;
          margin-bottom: 11px;

          .item-top {
            background: #f1f1f1;
            display: flex;
            align-items: center;
            padding: 4px 4px 4px 10px;

            .item-icon {
              margin-right: 6px;
              width: 21px;
              height: 14px;
              object-fit: contain;
            }

            .item-name {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 13px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              line-height: 18px;
              margin-right: 10px;
            }

            .group-list {
              display: flex;
              align-items: center;
              position: relative;

              .add {
                position: absolute;
                left: 50%;
                top: 50%;
                z-index: 1;
                transform: translate(-50%, -50%);
                width: 11px;
                height: 11px;
                font-size: 10px;
                border-radius: 50%;
                background: #727272;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .group-item {
                position: relative;
                box-sizing: border-box;
                width: 30px;
                height: 30px;
                border-radius: 3px;
                border: 1px solid #ffffff;
                margin-right: 3px;
                overflow: hidden;

                .group-image {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }

              .group-item:last-child {
                margin-right: 0;
              }
            }
          }

          .item-bottom {
            padding: 10px;
            display: flex;
            align-items: flex-start;
            background: #ffffff;

            .item-left {
              position: relative;
              width: 90px;
              height: 90px;
              border-radius: 6px;
              margin-right: 13px;

              .item-icon {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                overflow: hidden;
                object-fit: contain;
              }

              .item-brand {
                position: absolute;
                left: 0;
                top: 0;
                width: 45px;
                height: 15px;
                object-fit: cover;
                border-radius: 6px 0px 6px 0px;
              }
            }

            .item-center {
              min-height: 90px;
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              align-items: stretch;
              justify-content: space-between;

              .item-name {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                color: rgba(0, 0, 0, 0.8);
                line-height: 20px;
                margin-bottom: 4px;
              }

              .item-space {
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
              }

              .tag-list {
                display: flex;
                flex-wrap: wrap;

                .tag-item {
                  white-space: nowrap;
                  padding: 0px 3px;
                  font-size: 9px;
                  background: rgba(254, 248, 225, 1);
                  font-size: 10px;
                  font-family: PingFangSC, PingFang SC;
                  color: #fe8b1a;
                  line-height: 14px;
                  border-radius: 2px;
                  margin-right: 8px;
                  margin-bottom: 4px;
                }
              }

              .item-b-content {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;

                .item-num {
                  margin-top: 4px;
                  font-size: 10px;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  color: rgba(0, 0, 0, 0.5);
                  line-height: 14px;
                }

                .item-btn {
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  .buy-btn {
                    box-sizing: border-box;
                    width: 88px;
                    height: 28px;
                    background: #03d4e6;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: bold;
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .show-buy-padding {
    @include paddingBottom(76px);
  }
}
</style>
